// src/views/NewFile/NewFileView.js
import React from 'react';
import { TemplateModel } from '../../models/TemplateModel';
import { ViewTypes } from '../../models/SheetModel';

export const NewFileView = ({ onCreateBlank, onSelectTemplate, onCreateFromViewType }) => {
    const templates = TemplateModel.getTemplates();
    const availableViews = Object.values(ViewTypes);
    
    return (
        <div className="flex flex-col items-center justify-center h-full bg-gray-50 p-8">
            <h1 className="text-3xl font-bold mb-8">Create New Workbook</h1>
            
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 w-full max-w-5xl">
                {/* Option to create blank */}
                <div className="bg-white p-6 rounded-lg shadow hover:shadow-md transition-shadow cursor-pointer border border-gray-200">
                    <h2 className="text-xl font-semibold mb-3">Blank Workbook</h2>
                    <p className="text-gray-600 mb-4">Start with a fresh, empty workbook.</p>
                    <button
                        onClick={onCreateBlank}
                        className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                    >
                        Create Blank
                    </button>
                </div>

                {/* Create from View Type section */}
                <div className="bg-white p-6 rounded-lg shadow border border-gray-200 lg:col-span-2">
                    <h2 className="text-xl font-semibold mb-4">Start with a View</h2>
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
                        {availableViews.map(view => (
                            <div 
                                key={view.id}
                                className="p-4 border border-gray-200 rounded-lg hover:bg-gray-100 cursor-pointer flex flex-col items-center text-center"
                                onClick={() => onCreateFromViewType(view.id)}
                            >
                                <span className="text-3xl mb-2">{view.icon}</span>
                                <h3 className="font-medium text-sm">{view.label}</h3>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Templates section */}
                <div className="bg-white p-6 rounded-lg shadow border border-gray-200 lg:col-span-2">
                    <h2 className="text-xl font-semibold mb-4">Templates</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {templates.map(template => (
                            <div 
                                key={template.id}
                                className="p-4 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer"
                                onClick={() => onSelectTemplate(template.id)}
                            >
                                <div className="flex items-center mb-2">
                                    <span className="text-2xl mr-2">{template.icon}</span>
                                    <h3 className="font-medium">{template.name}</h3>
                                </div>
                                <p className="text-sm text-gray-600">{template.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};